import * as wizeMobileApi from '@wize-mobile-api';
import * as model from '@qvs/core';
import { UserCapabilities, UserRoleEnum } from '@qvs/core';

export class UserMapper {
  public static fromWizeUser(user: wizeMobileApi.UserMobile): model.Contact {
    return {
      email: user.publicEmail,
      lastName: user.surmame,
      name: user.name,
      domicile: user.domicile,
      phone: user.publicPhone,
      picture: user.profileIcon,
      staffId: user.id,
      contractId: user.identification
    };
  }

  public static fromWizeUserProfileRole(profile: wizeMobileApi.UserMobile): UserRoleEnum {
    if (profile.userType === wizeMobileApi.UserMobile.UserTypeEnum.CLIENT) {
      return UserRoleEnum.CLIENT;
    }
    if (profile.userType === wizeMobileApi.UserMobile.UserTypeEnum.CLIENT_CRM) {
      return UserRoleEnum.CLIENT_CRM;
    }
    return null;
  }

  public static fromUserProfileCapabilities(profile: wizeMobileApi.UserMobile): UserCapabilities {
    return {
      canCreateNewPaymentOrders: !!profile?.authorizedPaymentsAndTransfers,
      canUsePaymentScanner: !!profile?.authorizedScanAndPay && !!profile?.authorizedPaymentsAndTransfers,
      canCreateAccountToAccountTransfers: !!profile?.authorizedPaymentsAndTransfers,
      canUseAccessAppWithoutPushNotification: false
    };
  }

  static fromWizeUserProfileContacts(profile: wizeMobileApi.UserMobile): model.Contact[] {
    return profile.contacts?.map((contact) => UserMapper.fromWizeUser(contact)) ?? [];
  }
}
